import React, { PureComponent } from "react";
import Constants from "../Constants.js";

class MenuInnerTile extends PureComponent {
  render() {
    return (
      <div
        style={{
          width: Constants.menuTileSize + 'px',
          height: Constants.menuTileSize + 'px',
          position: 'absolute',
          backgroundColor: this.props.innerColor,
          borderTopLeftRadius: (this.props.topLeftRounded ? Constants.menuInnerBorderRadius : 0 ) + 'px',
          borderTopRightRadius: (this.props.topRightRounded ? Constants.menuInnerBorderRadius : 0 ) + 'px',
          borderBottomRightRadius: (this.props.bottomRightRounded ? Constants.menuInnerBorderRadius : 0 ) + 'px',
          borderBottomLeftRadius: (this.props.bottomLeftRounded ? Constants.menuInnerBorderRadius : 0 ) + 'px',
          left: (this.props.col * Constants.menuTileSize) + 'px',
          top: (this.props.row * Constants.menuTileSize) + 'px',
        }}
      />
    );
  }
}

export default MenuInnerTile;
